// Finding vocabulary of the executive summary cockpit.
//
// These read through ./i18n like every other label the renderer prints, so
// they follow the reader's language in user-interface and fall back to Spanish
// in admin-interface. They are functions rather than lookup tables because the
// table would be frozen at import time, before the host app registers its
// translator and before the reader can switch language.

import { t } from "./i18n";

const KEY = "dueDiligence.legalFiscalReport.blockRenderer";

const FINDING_CATEGORIES = [
  "high_risk", "attention", "no_incidents", "informative", "blocking",
] as const;
export type FindingCategory = (typeof FINDING_CATEGORIES)[number];

/**
 * @param category A finding's `category`, possibly missing or unrecognized.
 * @returns Its label, defaulting to "informative" — the renderer never leaves
 *          a finding unlabeled.
 */
export const findingCategoryLabel = (category: unknown): string => {
  const known = (FINDING_CATEGORIES as readonly unknown[]).includes(category);
  return t(`${KEY}.findingCategory.${known ? (category as FindingCategory) : "informative"}`);
};
